import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-returns',
  imports: [RouterOutlet],
  templateUrl: './returns.html',
  styleUrl: './returns.scss',
})
export class Returns {

}
